module.exports = __webpack_public_path__ + "static/media/home1_.ae00338d.svg";